// Constants used in the controllers
let urlRoutes = {
};

//Test and Prod
urlRoutes.HOST = ''
urlRoutes.PORT = ''
urlRoutes.PATH = '/rest'

// If localhost, talk to the dev environment
if(window.location.hostname === 'localhost') {
  urlRoutes.HOST = 'testportal.homesiteselections.com'
  urlRoutes.PORT = 443
}

module.exports = Object.freeze(urlRoutes);



// WEBPACK FOOTER //
// ./client/app/_helpers/urlPaths.js